import { queryClient } from '@/tanstack-query.ts';
import { OptionsUtil } from '@/modules/common/utils/options.util.ts';
import { CounterpartyQueryOptions } from '@/modules/counterparty/query-options/counterparty.query-options.ts';
import { LegalFormQueryOptions } from '@/modules/counterparty/query-options/legal-form.query-options.ts';
import { SegmentQueryOptions } from '@/modules/counterparty/query-options/segment.query-options.ts';
import { CategoryQueryOptions } from '@/modules/counterparty/query-options/category.query-options.ts';
import { ManagerQueryOptions } from '@/modules/counterparty/query-options/manager.query-options.ts';
import { RegionQueryOptions } from '@/modules/counterparty/query-options/region.query-options.ts';
import { CityQueryOptions } from '@/modules/counterparty/query-options/city.query-options.ts';

function byName<T extends { name: string }>(getList: (signal: AbortSignal) => Promise<T[]>) {
  return OptionsUtil.createSortedOptionsLoader(getList, (item) => item.name);
}

function byId<T extends { id: number; name: string }>(getList: (signal: AbortSignal) => Promise<T[]>) {
  return OptionsUtil.createSortedOptionsLoader(
    getList,
    (item) => item.name,
    (item) => item.id
  );
}

export class CounterpartyOptionsUtil {
  static types = byName((signal) => queryClient.ensureQueryData(CounterpartyQueryOptions.getTypes(signal)));

  static legalForms = byName((signal) => queryClient.ensureQueryData(LegalFormQueryOptions.getList(signal)));

  static segments = byName((signal) => queryClient.ensureQueryData(SegmentQueryOptions.getList(signal)));

  static segmentsById = byId((signal) => queryClient.ensureQueryData(SegmentQueryOptions.getList(signal)));

  static regions = byName((signal) => queryClient.ensureQueryData(RegionQueryOptions.getList(signal)));

  static regionsById = byId((signal) => queryClient.ensureQueryData(RegionQueryOptions.getList(signal)));

  static cities = (() => {
    const load = byName((signal) => queryClient.ensureQueryData(CityQueryOptions.getList(signal)));

    return async (signal: AbortSignal) => {
      const options = await load(signal);

      return options.filter((option) => option.label.replace(/\s+/gu, '').length > 0);
    };
  })();

  static priorities = byName((signal) => queryClient.ensureQueryData(CategoryQueryOptions.getList(signal)));

  static managers = byName((signal) => queryClient.ensureQueryData(ManagerQueryOptions.getList(signal)));

  static managersById = byId((signal) => queryClient.ensureQueryData(ManagerQueryOptions.getList(signal)));
}
